export default "/images/vendor/flag-icon-css/flags/1x1/no.svg?c2a3c34c769194e219c37f779b4021fb";